import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c8e833e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "group-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "group-metadata-container" }
const _hoisted_6 = { class: "group-name" }
const _hoisted_7 = { class: "group-name-detail detail" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 같이 먹어요! ")
const _hoisted_9 = {
  key: 0,
  class: "member-container"
}
const _hoisted_10 = { class: "member-detail detail" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, "도 같이 먹어요.", -1))
const _hoisted_12 = {
  key: 1,
  class: "member-container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "detail" }, "클릭"),
  /*#__PURE__*/_createTextVNode("해서 같이 먹을 사람이 누군지 확인해요!")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "timestamp"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 마감 ")
const _hoisted_17 = { class: "timestamp-detail detail" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 전이에요! ")
const _hoisted_19 = {
  key: 3,
  class: "timestamp"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 파티에 참여합니다! 🎉 ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 파티에 이미 참여하셨어요! 🎉 ", -1))

import { Timestamp } from "@firebase/firestore";
import { computed, onMounted, reactive, toRefs } from "vue";
import { useStore } from "vuex";
import Modal from "@/components/Modal.vue";
import { IGroupJoin } from "@/app/group/types";
import { TWENTY_MIN_BY_MS } from "@/assets/constants/constants";
import useModal from "@/hooks/useModal";
import { useRouter } from "vue-router";
import { ListType, TListType } from "../types";


export default /*#__PURE__*/_defineComponent({
  props: {
    groups: null
  },
  setup(__props: any) {

const props = __props as {
  groups: IGroupJoin[];
}

const store = useStore();
const router = useRouter();
const { isModalOpen, closeModal, openModal } = useModal();
const timestamp = Timestamp;



const state = reactive({
  clickedGroupId: router.currentRoute.value.params.id || "",
  TWENTY_MIN_BY_MS: TWENTY_MIN_BY_MS,
});

onMounted(() => {
  const isRoutedByGroupId = router.currentRoute.value.params.id ? true : false;

  if (!isRoutedByGroupId) return;
  openModal();
});

const { groups } = toRefs(props);

function participateInGroup() {
  closeModal();

  if (clickedGroup.value?.lead.uid === currentUser.value.uid) {
    alert("이미 참여하셨어요!");
    return;
  }
  if (
    clickedGroup.value &&
    clickedGroup.value.createdAt.toMillis() + TWENTY_MIN_BY_MS <
      timestamp.now().toMillis()
  ) {
    alert("마감됐습니다.");
    return;
  }

  store.dispatch("GroupStore/participateInGroupAsync", state.clickedGroupId);
}

function setIsModalOpen(event: Event, isOpen: boolean, groupId: string) {
  isModalOpen.value = isOpen;
  state.clickedGroupId = groupId;
}

async function shareLink() {
  await navigator.clipboard.writeText(
    `https://what-should-we-eat.vercel.app/#/${state.clickedGroupId}`
  );

  alert("링크를 클립보드에 저장했어요!");
  closeModal();
}

const participatedUsers = computed(() => {
  return groups.value.find(
    (group: IGroupJoin) => group.id === state.clickedGroupId
  )?.users;
});

const clickedGroup = computed(() => {
  return groups.value.find(
    (group: IGroupJoin) => group.id === state.clickedGroupId
  );
});

const currentUser = computed(() => store.getters["UserStore/getCurrentUser"]);

const isParticipatedUser = computed(() =>
  clickedGroup.value?.users
    .map((user) => user.uid)
    .includes(currentUser.value.uid)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groups), (group) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "group-item",
          key: group.id,
          onClick: ($event: any) => (setIsModalOpen($event, true, group.id))
        }, [
          _createElementVNode("img", {
            class: "menu-image",
            src: group.menu.imgSrc
          }, null, 8, _hoisted_4),
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(group.menu.name), 1),
              _hoisted_8
            ]),
            (group.users.length < 3)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.users, (user) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "memeber-item",
                      key: user.uid
                    }, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(user.name) + "님", 1)
                    ]))
                  }), 128)),
                  _hoisted_11
                ]))
              : (_openBlock(), _createElementBlock("ul", _hoisted_12, _hoisted_14)),
            (
              group.createdAt.toMillis() + _unref(TWENTY_MIN_BY_MS) >
              _unref(timestamp).now().toMillis()
            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, _toDisplayString(20 -
                parseInt(
                  _unref(timestamp).fromMillis(
                    _unref(timestamp).now().toMillis() - group.createdAt.toMillis()
                  ).seconds / 60
                )) + " 분 ", 1),
                  _hoisted_18
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_19, "파티가 만들어진 지 20분이 지나 마감됐어요!"))
          ])
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _withDirectives(_createVNode(Modal, null, {
      header: _withCtx(() => [
        _hoisted_20
      ]),
      body: _withCtx(() => [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(participatedUsers), (user) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "group-detail detail",
              key: user.id
            }, _toDisplayString(user.name) + " 님 ", 1))
          }), 128)),
          _createTextVNode(" " + _toDisplayString(_unref(participatedUsers)?.length) + " 명과 함께 먹을 수 있어요! ", 1)
        ])
      ]),
      "footer-yes-button": _withCtx(() => [
        _createElementVNode("button", {
          type: "text",
          onClick: participateInGroup
        }, "네!")
      ]),
      "footer-close-button": _withCtx(() => [
        _createElementVNode("button", {
          type: "text",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(closeModal) && _unref(closeModal)(...args)))
        }, "다음에 참여할게요")
      ]),
      _: 1
    }, 512), [
      [_vShow, _unref(isModalOpen) && !_unref(isParticipatedUser)]
    ]),
    _withDirectives(_createVNode(Modal, null, {
      header: _withCtx(() => [
        _hoisted_21
      ]),
      body: _withCtx(() => [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(participatedUsers), (user) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "group-detail detail",
              key: user.id
            }, _toDisplayString(user.name) + " 님 ", 1))
          }), 128)),
          _createTextVNode(" " + _toDisplayString(_unref(participatedUsers)?.length) + " 명과 함께 먹을 수 있어요! ", 1)
        ]),
        _createElementVNode("span", {
          class: "share-link-text",
          onClick: shareLink
        }, " 파티 링크를 공유할까요? ")
      ]),
      "footer-yes-button": _withCtx(() => [
        _createElementVNode("button", {
          type: "text",
          onClick: shareLink
        }, "네!")
      ]),
      "footer-close-button": _withCtx(() => [
        _createElementVNode("button", {
          type: "text",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(closeModal) && _unref(closeModal)(...args)))
        }, "다음에 공유할게요")
      ]),
      _: 1
    }, 512), [
      [_vShow, _unref(isModalOpen) && _unref(isParticipatedUser)]
    ])
  ]))
}
}

})